import { Routes } from '@angular/router';
import { UnAuthGuard } from '@/core/configuration/un-auth.guard';
import { authGuard } from '@/core/configuration/authGuard';
import { Forbidden } from '@/core/page/forbidden/forbidden.component';
import { Notfound } from '@/core/page/not-found/notfound';
import { AppLayout } from '@/layout/components/app.layout';
import { APP_ROUTES } from '@/app.router.config';

// Trimmed to what exists in the sandbox (login + layout + dashboard).
// Feature modules (@/module/*) will be added back as they are provided.
export const appRoutes: Routes = [
  {
    path: 'auth/login',
    canActivate: [UnAuthGuard],
    loadComponent: () => import('@/core/page/login/login').then((m) => m.Login),
  },
  {
    path: 'auth/forgot-password',
    canActivate: [UnAuthGuard],
    loadComponent: () => import('@/core/page/auth/forgot-password/forgot-password').then((m) => m.ForgotPassword),
  },
  {
    path: 'auth/verify-code',
    canActivate: [UnAuthGuard],
    loadComponent: () => import('@/core/page/auth/verify-code/verify-code').then((m) => m.VerifyCode),
  },
  {
    path: 'auth/set-password',
    canActivate: [UnAuthGuard],
    loadComponent: () => import('@/core/page/auth/set-password/set-password').then((m) => m.SetPassword),
  },
  {
    path: '',
    component: AppLayout,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: APP_ROUTES.DASHBOARD,
        data: { breadcrumb: 'menu.dashboard' },
        loadComponent: () => import('@/pages/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: APP_ROUTES.TENANT,
        data: { breadcrumb: 'module.tenant.label' },
        loadChildren: () => import('@/modules/tenant/tenant.routes'),
      },
    ],
  },
  { path: 'notfound', component: Notfound },
  { path: '403', component: Forbidden },
  { path: '**', redirectTo: '/notfound' },
];
